import React from 'react'
import { useNavigate } from 'react-router-dom'

const PrivacyPolicyPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className="sticky top-0 px-6 py-6 flex justify-between items-center z-50 shadow-md"
        style={{ backgroundColor: '#2C2B69' }}>
        <div className="container mx-auto flex justify-between items-center">
          <div
            className="text-2xl font-bold text-white cursor-pointer"
            onClick={() => navigate('/')}>
            My Cap Gains
          </div>
          <div className="flex gap-4">
            <button
              onClick={() => navigate('/auth/login')}
              className="px-6 py-2 text-white hover:text-blue-200 transition">
              Login
            </button>
            <button
              onClick={() => navigate('/auth/signup')}
              className="px-6 py-2 bg-white rounded-lg hover:bg-blue-50 transition font-semibold"
              style={{ color: '#42419E' }}>
              Get Started
            </button>
          </div>
        </div>
      </nav>

      {/* Privacy Policy Content */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Privacy Policy
            </h1>

            <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
              <p>
                This Privacy Policy sets forth the terms under which Cap Gains uses and
                protects the information that is provided by its users when using its
                website. This company is committed to the security of its users' data.
                When we ask you to provide personal information by which you can be
                identified, we do so with the assurance that it will only be used in
                accordance with the terms of this document. However, this Privacy Policy
                may change over time or be updated and we encourage and emphasize that you
                should continually review this page to ensure that you agree to any such
                changes.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                Information that is collected
              </h2>
              <p>
                Our website may collect personal information such as your name, contact
                information such as your email address and demographic information. Also,
                when necessary, specific information may be required to process an order
                or make a delivery or billing.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                Use of Information Collected
              </h2>
              <p>
                Our website uses the information in order to provide the best possible
                service, particularly to keep track of users, to keep track of orders if
                applicable, and to improve our products and services. We may periodically
                send emails through our site with special offers, new products and other
                marketing information that we think may be relevant to you or that you may
                find interesting or useful. These emails will be sent to the address you
                provide and may be unsubscribed at any time. Cap Gains is highly committed
                to fulfilling our commitment to keeping your information secure. We use
                the most advanced systems and constantly update them to ensure that there
                is no unauthorized access.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Cookies</h2>
              <p>
                A cookie refers to a file that is sent with the purpose of requesting
                permission to be stored on your computer, by accepting this file is
                created and the cookie is then used to have information regarding web
                traffic, and also facilitates future visits to a recurring website.
                Another function that cookies have is that with them the web can recognize
                you individually and therefore provide you with the best personalized
                service on its website.
              </p>
              <p>
                Our website uses cookies to identify the pages that are visited and their
                frequency. This information is used only for statistical analysis and then
                the information is permanently deleted. You can delete cookies at any time
                from your computer. However, cookies help to provide a better service of
                the websites, they do not give access to information from your computer or
                from you, unless you choose to provide it directly to us. You can accept
                or deny the use of cookies, however most browsers automatically accept
                cookies as it serves to have a better web service. You can also change the
                settings on your computer to decline cookies. If you decline cookies you
                may not be able to use some of our services.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                Links to Third Parties
              </h2>
              <p>
                This website may contain links to other sites that may be of interest to
                you. Once you click on these links and leave our site, we no longer have
                control over the site to which you are redirected and therefore we are not
                responsible for the terms or privacy or data protection of those other
                third party sites. Those sites are subject to their own privacy policies
                and we recommend that you check with them to confirm that you agree with
                them.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                Control of your personal information
              </h2>
              <p>
                At any time you may restrict the collection or use of personal information
                that is provided to our website. Whenever you are asked to fill out a
                form, such as a user registration form, you can check or uncheck the
                option to receive information by e-mail. In case you have checked the
                option to receive our newsletter or advertising you can cancel it at any
                time.
              </p>
              <p>
                This company will not sell, give away or distribute the personal
                information that is collected without your consent, unless required by a
                judge with a court order.
              </p>
              <p className="font-semibold">
                Cap Gains reserves the right to change the terms of this Privacy Policy at
                any time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="mt-20 border-t border-gray-200 pt-12 pb-8 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">My Cap Gains</h3>
              <p className="text-gray-600">
                Simplifying capital gains tax calculations for investors worldwide.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Product</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="/#features"
                    className="text-gray-600 hover:text-blue-600 transition">
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href="/#pricing"
                    className="text-gray-600 hover:text-blue-600 transition">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="/faq" className="text-gray-600 hover:text-blue-600 transition">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Company</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-600 hover:text-blue-600 transition">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-blue-600 transition">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-blue-600 transition">
                    Careers
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="/privacy-policy"
                    className="text-gray-600 hover:text-blue-600 transition">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-blue-600 transition">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-blue-600 transition">
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8 text-center text-gray-600">
            <p>&copy; 2024 My Cap Gains. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default PrivacyPolicyPage
